// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-threat-specific-awareness-training.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-threat-specific-awareness-training',
  title:
    'Deliver threat-specific security awareness training (phishing, social engineering, deepfakes)',
  description:
    'Security awareness training must specifically cover: phishing attacks and how to recognise them; social engineering and manipulation techniques; unintentional information leakage; emerging threats such as deepfakes and digital impersonation; and the importance of clear-desk and screen-lock policies.',
  category: 'people',
  scfIds: ['SCF-PPL-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Threat-specific awareness training programme is documented',
    },
    {
      type: 'document-within-sla',
      description: 'Training content is current and not overdue for refresh',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
